import { Dispatch, createSlice } from "@reduxjs/toolkit";
import { Address, Cell } from "@ton/core";
import { PRESALE_ADDRESS, PRESALE_WALLET_CODE, STAKE_WALLET_CODE } from "constant";
import { zeroAddress } from "lib/utils";
import { getPresaleWalletData, Presale } from "wrappers/presale";

interface DriverState {
  globalData: any;
  userData: any;
}

const initialState: DriverState = {
  globalData: {},
  userData: {}
};

const presaleSlice = createSlice({
  name: "presaleSlice",
  initialState,
  reducers: {
    getAllPresaleData(state, action) {
      state.globalData = action.payload;
    },
    getPresaleUserdata(state, action) {
      state.userData = action.payload;
    },
  },
});

export function getGlobalDataPresale() {
  return async (dispatch: Dispatch) => {
    const presaleContractAddress = Address.parse(PRESALE_ADDRESS ?? zeroAddress);
    let presaleContract = Presale.createFromAddress(presaleContractAddress);
    const presaleData = await presaleContract.getPRESALEData();
    dispatch(presaleSlice.actions.getAllPresaleData(presaleData))  
  };
}

export function getUserDataPresale(userWalletAddress: any) {
  return async (dispatch: Dispatch) => {
    try {
      const wallet_code = Cell.fromBase64(PRESALE_WALLET_CODE);
        const walletAddress = Presale.createWalletAddressFromConfig( {
          ownerAddress: Address.parse(userWalletAddress),
          presaleAddress: Address.parse(PRESALE_ADDRESS)
        },
        wallet_code
      )
      const walletData = await getPresaleWalletData(walletAddress.toString());
      dispatch(presaleSlice.actions.getPresaleUserdata(walletData));
    } catch (error) {
      console.log(error);
    }
  };
}

const presaleReducer = presaleSlice.reducer;

export default presaleReducer;
